import React from 'react';
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";

import ScrollToTop  from './pages/components/scroll-top-page/scroll-top-page';

import MyNavbar from './pages/components/navbar/mynavbar';
import HomePage from './pages/home/HomePage';
import Azienda from './pages/azienda/AziendaPage';
import Progetti from './pages/progetti/ProgettiPage';
import Contatti from './pages/contatti/ContattiPage';

import CookiePolicy from "./documents/cookie-policy"
import PrivacyPolicy from "./documents/privacy-policy"

import CookieBanner from './pages/components/cookie-banner/cookie-banner';
import './pages/components/cookie-banner/cookie-banner.css';


function App() {
  return (
    <React.StrictMode>
      <BrowserRouter>

        <ScrollToTop />

        <CookieBanner />

        <RenderNavbar />
        
        <Routes>
          <Route path="/kestrel-website" exact element={<HomePage />} />
          <Route path="/" exact element={<HomePage />} />
          <Route path="/azienda" exact element={<Azienda />} />
          <Route path="/progetti" exact element={<Progetti />} />
          <Route path="/contatti" exact element={<Contatti />} />

          <Route path="/cookie-policy" exact element={<CookiePolicy />} />
          <Route path="/privacy-policy" exact element={<PrivacyPolicy />} />
        </Routes>

      </BrowserRouter>
    </React.StrictMode>
  );
}

function RenderNavbar() {
  const location = useLocation();

  // Do not render navbar on "/cookie-policy" and "/privacy-policy" pages
  if (location.pathname === '/cookie-policy' || location.pathname === '/privacy-policy') {
    return null; // Do not render the navbar
  }

  return <MyNavbar />; // Render the navbar for other pages
}

export default App;
